import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { AccountService } from '../../../services';
import { RecoverAccountModel } from '../../../models/account';
import { AppUtils } from '../../../helpers';

declare var activateFormLineControlPlaceholder: any;

@Component({
    selector: 'recover-account',
    templateUrl: './account.recover.component.html'
})

export class AccountRecoverComponent implements OnInit {
    @BlockUI('frm-recover') blockUI: NgBlockUI;

    requestCompleted: boolean;
    model: RecoverAccountModel = new RecoverAccountModel();

    constructor(private vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private accountService: AccountService) {
        this.toastr.setRootViewContainerRef(this.vcr);
        this.requestCompleted = false;
    }

    ngOnInit() {
        activateFormLineControlPlaceholder();
    }

    submit() {
        this.blockUI.start();
        this.accountService.recoverAccount(this.model)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    this.requestCompleted = true;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}



// WEBPACK FOOTER //
// ./src/components/account/recover/account.recover.component.ts